import { takeLatest, call, put } from 'redux-saga/effects';
import {
	setNavHeaderVisibleAction,
	ITkbRepsonse,
	setTkbAction,
	getTkbAction,
	getWidgetProgressAction,
	IWidgetProgressResponse,
	setWidgetProgressAction,
} from '../actions/NavHeaderAction';
import apiRequest from '../api/api.request';
import endpoints from '../../../constants/endpoints';
import { ApiRequestConfig } from '../../interfaces/api-request/api.interface';

function setNavHeaderVisibleSaga({ payload }: { payload }): void {
	try {
		return payload;
	} catch (err) {
		return payload;
	}
}

function* getTkbSaga(): Generator {
	const config: ApiRequestConfig = {
		path: endpoints.api.TKB,
		method: 'GET',
		headers: {
			Platform: `WEB`,
			Language: `ID`,
		},
		query: '',
		body: null,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		yield put(setTkbAction(res as ITkbRepsonse));
		return res;
	} catch (err) {
		return err;
	}
}

function* getWidgetProgressSaga(): Generator {
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.WIDGET_PROGRESS,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
			"X-Authenticated-Userid": `${JSON.parse(auth).userId}`,
		},
		query: '',
		body: null,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		yield put(setWidgetProgressAction(res as IWidgetProgressResponse));
		return res;
	} catch (err) {
		return err;
	}
}

export default function* navHeaderSaga(): Generator {
	yield takeLatest(setNavHeaderVisibleAction, setNavHeaderVisibleSaga);
	yield takeLatest(getTkbAction, getTkbSaga);
	yield takeLatest(getWidgetProgressAction, getWidgetProgressSaga);
}
